import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
	return (
		<div className="footer">
			<div className="p24-grafiki"><img src="\p24\flagi_Przelewy24_1-1.png" alt="flagi-p24" style={{ maxWidth: "60%", height: "20%" }}/></div>
			<ul className="footer-list">
				<li>&copy; 2026 Kwiaty z Gór</li>
				<li><a
				href="/pdf/politykaprywatnosci.pdf"
				target="_blank"
				rel="noopener noreferrer"
			 className="footer-link">Polityka Prywatności</a></li>
			<li><a
				href="/pdf/regulamin.pdf"
				target="_blank"
				rel="noopener noreferrer"
			 className="footer-link">Regulamin sklepu</a></li>
			<li><a
				href="/pdf/odstapienie.pdf"
				target="_blank"
				rel="noopener noreferrer"
			 className="footer-link">Warunki Odstąpienia</a></li>
			</ul>
		</div>
	);
};

export default Footer;
